import { assignSafe, SBaseDisplay } from '@summit/core';
import { v4 as uuid } from 'uuid';

import { Hub } from '../places/hub/hub';
import { LinehaulRun } from './linehaul-run';

export class LinehaulRunDetail implements SBaseDisplay {
  id: string;
  name: string;
  linehaulRunID: string;
  linehaulRun: LinehaulRun;
  leg: number;
  originHubID: number;
  originHub: Hub;
  destHubID: number;
  destHub: Hub;
  laneDestinationHubID: string;
  laneDestinationHub: Hub;
  dayOfWeekString: string;
  altWeek: number;

  constructor(jsonData: Partial<LinehaulRunDetail>) {
    assignSafe(this, jsonData);
    if (jsonData.linehaulRun) {
      this.linehaulRun = new LinehaulRun(jsonData.linehaulRun);
    }
    if (jsonData.originHub) {
      this.originHub = new Hub(jsonData.originHub);
    }
    if (jsonData.destHub) {
      this.destHub = new Hub(jsonData.destHub);
    }
    if (jsonData.originHub) {
      this.laneDestinationHub = new Hub(jsonData.laneDestinationHub);
    }
    if (!this.id) {
      this.id = uuid();
    }
  }

  toShortString(): string {
    if (this.altWeek) {
      return `W${this.altWeek}: #${this.leg}:${this.originHubID}->${this.destHubID}|>${this.laneDestinationHubID}[${this.dayOfWeekString}]`;
    }
    return `#${this.leg}:${this.originHubID}->${this.destHubID}|>${this.laneDestinationHubID}[${this.dayOfWeekString}]`;
  }
}
